<template>
    <div class="setting-wrap">
        <h2>개인정보 변경</h2>
        {{ $router.path }}
        <div class="user-list-wrap">
            <ul class="user-list clearfix">
                <li class="clearfix">
                    <label for="user-email">이메일</label>
                    <input type="text" name="user-email" id="user-email" :value="pharm.email" readonly="readonly">
                </li>
                <li class="clearfix">
                    <label for="user-name">약사(약국)명 <em>*</em></label>
                    <div class="tel-group">
                        <input type="text" name="user-name" id="user-name" v-model="pharm.pharm_name" v-validate="'required|min:2'">
                        <p v-show="errors.has('user-name')" class="error-msg">약사(약국)명은 2자 이상 입력하셔야 합니다.</p>
                    </div>
                </li>
                <!--<li class="clearfix">-->
                    <!--<label for="">성별 <em>*</em></label>-->
                    <!--<ul class="sex-radio">-->
                        <!--<li>-->
                            <!--<input type="radio" name="sex-user" id="sex-man" checked>-->
                            <!--<label for="sex-man">남</label>-->
                        <!--</li>-->
                        <!--<li>-->
                            <!--<input type="radio" name="sex-user" id="sex-woman">-->
                            <!--<label for="sex-woman">여</label>-->
                        <!--</li>-->
                    <!--</ul>-->
                <!--</li>-->
                <li class="clearfix">
                    <label for="tel-num">휴대폰 <em>*</em></label>
                    <div class="tel-group clearfix">
                        <select name="tel-num1" id="tel-num1" :value="pharm.nation_code"  v-model="pharm.nation_code" size="1" v-validate="'required|numeric'">
                            <option value="82">한국</option>
                            <option value="1">미국</option>
                        </select>
                        <span class="tel-space">-</span>
                        <input type="tel" name="tel-num2" id="tel-num2" v-model="pharm.contact" v-validate="'required|min:10|numeric'">
                        <p style="color:red" v-show="errors.has('tel-num1') || errors.has('tel-num2')" class="error-msg">휴대폰 국가는 필수이고 번호는 10자리 이상이어야 합니다.</p>    
                        <!--<button type="button" class="send-btn">인증번호 발송</button>-->
                    </div>
                    <!--<div class="sms-agree-wrap clearfix">-->
                        <!--<input type="checkbox" name="sms-agree" id="sms-agree">-->
                        <!--<label for="sms-agree">SMS 수신동의</label>-->
                    <!--</div>-->
                </li>
                <!--<li class="clearfix">-->
                    <!--<label for="user-email">주소 <em>*</em></label>-->
                    <!--<input type="text" name="user-addr" id="user-addr">-->
                <!--</li>-->
                <!--
                <li>
                    <label for="">생년월일 <em>*</em></label>
                    <el-date-picker
                        v-model="dr.birthday"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="Pick a date">
                    </el-date-picker>
                </li>
                -->
            </ul>
        </div>
        <p class="modify-btn"><button type="button" @click="save_pharmacist">수정완료</button></p>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { STATUS_CODE } from '@/lib/constants'
  export default {
    name: 'pharm-info',
    data () {
      return {
        dialogTableVisible: false,
        //phone_array: ['', '', ''],
        upload_obj: null,
        preview_src: null,
        birthday: '1980-01-01',
        pharm: {
          pharm_id: null,
          pharm_name: null,
          email: null,
          contact: null,
          nation_code: null,
        }
      }
    },
    computed: {
      ...mapState(['account'])
    },
    methods: {
      async getPharmData (pharm_id) {

        let chosen_fields = Object.keys(this.pharm)
        let {data: {resp}} = await this.axios.get(`pharmacist/${pharm_id}`)

        for (let key of chosen_fields) {
          if (key in resp) {
            this.pharm[key] = resp[key]
          }
        }

        if (this.pharm.contact) this.pharm.contact = this.pharm.contact.replace(/-/gi,'')

        // if (this.pharm.contact) {
        //   this.phone_array = this.pharm.contact.split('-')
        // } else {
        //   return ['', '', '']
        // }

        // console.log('getPharmData')
        // this.dr = resp
      },
      async save_pharmacist () {
        let is_form_valid = await this.$validator.validateAll()
        // console.log(this.errors.any());
        if (is_form_valid) {
            if (!this.pharm.pharm_id) throw new Error('pharm_id가 존재하지 않습니다')

            //this.dr.contact = this.phone_array.join('-')
            let { data } = await this.axios.post(`pharmacist/${this.pharm.pharm_id}`, this.pharm)
            if (data.status != STATUS_CODE.OK) return alert(data.msg)

            alert('회원정보가 수정되었습니다!')
        } else {
          alert('입력내용을 다시 확인해 주세요!')
          return false;
        }

      },
    //   phone_change (idx, value) {
    //     this.phone_array.splice(idx, 1, value)
    //   }
    },
    mounted () {
      // Todo: 인증 정보에서 dr_id를 가져온다
      this.getPharmData(this.account.pharm_id)
    }
  }
</script>

<style scoped>
    .setting-wrap {
        width: 100%;
        padding: 30px;
        background-color: #fff;
        border: 1px solid #eee;
        box-sizing: border-box;
    }

    .setting-wrap > h2 {
        margin-bottom: 15px;
        font: 400 18px 'Noto Sans KR', sans-serif;
    }

    .setting-wrap > p {
        color: #b2b2b2;
        font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .user-list > li {
        margin-bottom: 15px;
    }

    .user-list > li label
     {
        float: left;
    }
    .user-list .tel-group{overflow: hidden;}
    .user-list > li label {
        width: 150px;
        position: relative;
        font: 400 16px/50px 'Noto Sans KR', sans-serif;
    }

    .user-list > li label em {
        color: #ff316d;
        position: absolute;
        top: 5px;
        margin-left: 5px;
    }

    .user-list > li input {
        display: inline-block; padding:0 10px;
        box-sizing: border-box;
    }

    #user-email {
        border: none;
        letter-spacing: .5px;
        font: 500 16px/50px 'Noto Sans KR', sans-serif;
    }

    #user-name, #tel-num2 {
        width: 400px;
        height: 50px;
        font: 500 16px/50px 'Noto Sans KR', sans-serif;
    }

    #sex-man, #sex-woman {display: none;}

    .sex-radio {font-size: 0;}
    .sex-radio > li {
        display: inline-block;
        text-indent: 35px;
        font: 500 16px/50px 'Noto Sans KR', sans-serif;
    }

    .user-list .sex-radio label {width: 80px;}
    .sex-radio label {position: relative;}
    #sex-man + label[for*="sex-man"]::before,
    #sex-woman + label[for*="sex-woman"]::before {
        content: '';
        display: block;
        width: 20px;
        height: 20px;
        position: absolute;
        left: 0;
        top: 50%;
        border-radius: 50%;
        transform: translateY(-50%);
        border: 2px solid #a9a9a9;
        box-sizing: border-box;
    }

    #sex-man:checked + label[for*="sex-man"]::before,
    #sex-woman:checked + label[for*="sex-woman"]::before {
        padding: 3px;
        border-color: #746ce6;
        background-color: #746ce6;
        background-clip: content-box;
    }
    
    #tel-num1,
    .tel-space{display: inline-block;}

    .send-btn {float: left;}

    .tel-group select,
    .tel-group input {
        width: 118px;
        height: 50px;
        border: 1px solid #d2d2d2;
    }

    #tel-num1 {
        padding: 0 15px;
        font: 400 16px 'Noto Sans KR', sans-serif;
        background: url(../../assets/home/select.png) 90% center/10% no-repeat;
    }

    .tel-space {
        margin: 0 8px;
        font: 500 16px/50px 'Noto Sans KR', sans-serif;
    }

    .send-btn {
        color: #fff;
        width: 125px;
        height: 50px;
        border: none;
        margin-left: 10px;
        background-color: #9c9c9c;
        font: 400 16px/50px 'Noto Sans KR', sans-serif;
    }

    .sms-agree-wrap {margin-left: 150px;}
    #sms-agree {display: none;}

    .sms-agree-wrap label {
        position: relative;
        text-indent: 30px;
    }

    .sms-agree-wrap label::before {
        content: '';
        display: block;
        width: 20px;
        height: 20px;
        box-sizing: border-box;
        border: 1px solid #d2d2d2;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
    }

    #sms-agree:checked + label::before {
        border-color: #736ee6;
        background: url(../../assets/home/checked.png) center center/14px no-repeat;
    }

    #user-addr {
        width: 400px;
        height: 50px;
        border: 1px solid #d2d2d2;
    }

    .birth-group > select {
        width: 125px;
        height: 50px;
        padding: 0 15px;
        margin-right: 12px;
        border: 1px solid #d2d2d2;
        font: 400 16px/50px 'Noto Sans KR', sans-serif;
        background: url(../../assets/home/select.png) 90% center/10% no-repeat;
    }

    .modify-btn {
        width: 120px;
        height: 50px;
        margin: 30px 0 0 150px;
        background-color: #746ce6;
    }

    .modify-btn button {
        color: #fff;
        width: 100%;
        height: 100%;
        border: none;
        text-align: center;
        background-color: transparent;
        font: 400 16px/50px 'Noto Sans KR', sans-serif;
    }

    .error-msg {
        line-height: 40px; 
        color: #746ce5 !important;
    }
</style>